import { type FC, PropsWithChildren } from 'react'
import { useIsFeatureAdvertisementEnabled } from '../../common/useIsFeatureAdvertisementEnabled'

interface FeatureAdvertisementProps extends PropsWithChildren {
  bypass?: boolean
}

export const FeatureAdvertisement: FC<FeatureAdvertisementProps> = ({ bypass, children }) => {
  const { isEnabled } = useIsFeatureAdvertisementEnabled({ bypass })

  if (!isEnabled) {
    return null
  }

  return <>{children}</>
}
